module.exports = __webpack_public_path__ + "static/media/logo_1.101b1de7.png";